import React, { Component } from 'react';
import {Link} from "react-router-dom";
import grades from "../../../common/grades";
import './add-students-flow.less'
import '../MyStudentsPage/my-students.less'
import trackEvent from '../eventTracking';

let tempGrades = {};
grades.GRADES.forEach(function(grade){
  tempGrades[grade.short] = grade.simple;
});
const GRADES = tempGrades;

class SelectGrade extends Component {
  constructor(props) {
    super(props);

    this.state = {
      gradeText: this.props.gradeText || 'K',
      grade: this.props.grade || 'kindergarten'
    }

    window.scrollTo(0, 0);  // Reset page scroll
  }

  /////////////////////////////////
  // Helper Functions
  /////////////////////////////////

  handleGoBack = () => {
    this.props.goBack(this.state);
  }

  handleDone = () => {
    trackEvent('add', 'completed', true);

    this.props.handleDone(this.state);
  }

  gradeButtonClicked = (gradeText) => {
    this.setState({
      gradeText: gradeText,
      grade: GRADES[gradeText]
    })
  }

  getButtonPerGrade = (gradeText) => {
    return (
      <label key={gradeText} className='clear-button' onClick={() => this.gradeButtonClicked(gradeText)}>
        <div>
          <div className={"border " + (gradeText === this.state.gradeText ? "selected-button" : "")}>
          </div>
          <div className={"text " + (gradeText === this.state.gradeText ? "selected-button-text" : "")}>
            <div className="top grades">{gradeText}</div>
          </div>
        </div>
      </label>
    )
  }

  /////////////////////////////////

  render() {
    let instruction = 'Choose a grade to apply to ';
    if (this.props.numStudentsToAdd === 1) {
      instruction += '1 ' + this.props.yourX.singular + ':';
    } else {
      instruction += this.props.numStudentsToAdd + ' ' + this.props.yourX.plural + ':';
    }

    return (
      <div className="main-container select-grade">
        <div className="select-grade-pieces-container" data-cy="select-grade-section">
          <div className="instruction">
            {instruction}
          </div>

          <div className="form">
            {Object.keys(GRADES).map(gradeText => {return this.getButtonPerGrade(gradeText)})}
          </div>

          {/*Note to user*/}
          <div className="bulk-edit-note-to-user">
            You can always change this later for each student.
          </div>

          {/*Actions*/}
          <div className="bottom-buttons">
            <div className="button-container"><button className="btn btn-secondary" onClick={()=>this.handleGoBack()}>Back</button></div>
            <div className="button-container"><Link className="btn btn-primary btn-done" to="/my/students/" onClick={()=>{this.handleDone()}}>Done</Link></div>
          </div>
        </div>
      </div>
    )
  }
}

export default SelectGrade;
